var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCerrarSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.999,
    viewBox: "0 0 17 16.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d3097f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M656.142,183.095a8.555,8.555,0,0,1,0,8.534,8.454,8.454,0,0,1-3.094,3.092,8.552,8.552,0,0,1-8.532,0,8.438,8.438,0,0,1-3.094-3.092,8.555,8.555,0,0,1,0-8.534A8.443,8.443,0,0,1,644.517,180a8.506,8.506,0,0,1,11.626,3.094ZM653,189.862a.69.69,0,0,0-.212-.5l-2-2,2-2a.69.69,0,0,0,.212-.5.7.7,0,0,0-.212-.51l-1-1a.692.692,0,0,0-.508-.212.675.675,0,0,0-.5.212l-2,2-2-2a.681.681,0,0,0-.5-.212.693.693,0,0,0-.508.212l-1,1a.7.7,0,0,0-.21.51.679.679,0,0,0,.21.5l2,2-2,2a.679.679,0,0,0-.21.5.7.7,0,0,0,.21.508l1,1a.691.691,0,0,0,.508.21.679.679,0,0,0,.5-.21l2-2,2,2a.673.673,0,0,0,.5.21.682.682,0,0,0,.508-.21l1-1a.694.694,0,0,0,.21-.506Z",
    transform: "translate(-640.283 -178.861)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSesion);
export default __webpack_public_path__ + "static/media/cerrar_sesion.fbf1088db4374520687e12a7e723671a.svg";
export { ForwardRef as ReactComponent };